import { Button, ButtonGroup } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { WeekPicker } from "@msuite/ui/week-picker";
import { usePlanStore } from "@/components/plan/store";

export function PlanHeader() {
	/** Hooks */
	const { t } = useTranslation();

	/** Store */
	const planStore = usePlanStore();

	/** Render */
	return (
		<div className="h-stack justify-between pr-4">
			<WeekPicker
				currentWeek={planStore.currentWeek}
				onBack={planStore.previousWeek}
				onForward={planStore.nextWeek}
			/>
			<ButtonGroup isAttached={false}>
				<SegmentedControl
					value={planStore.mode}
					items={[
						{
							label: t("planning.daily_planning"),
							value: "daily",
							cyId: "plan-mode-daily",
						},
						{
							label: t("planning.capacity_planning"),
							value: "capacity",
							cyId: "plan-mode-capacity",
						},
					]}
					onChange={planStore.setMode}
				/>
				<Button
					icon={
						<Icon
							name="Combine"
							color={planStore.showResources ? "var(--color-accent-500)" : undefined}
						/>
					}
					onClick={planStore.toggleShowResources}
				>
					{t("planning.resources")}
				</Button>
			</ButtonGroup>
		</div>
	);
}
